"use strict";
/**
 * @module SessionFetchRequest
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Implementation of the SessionFetchResultImpl interface
 */
var SessionFetchResultImpl = /** @class */ (function () {
    /**
     * Create a new SessionFetchResultImpl instance
     *
     * @param result    the results
     */
    function SessionFetchResultImpl(results, totalSelected) {
        this.resultList = results;
        this.totalSelectedCount = totalSelected;
        this.hasMoreFlag = results.length < totalSelected;
    }
    /**
     * @inheritdoc
     */
    SessionFetchResultImpl.prototype.results = function () {
        return this.resultList;
    };
    /**
     * @inheritdoc
     */
    SessionFetchResultImpl.prototype.hasMore = function () {
        return this.hasMoreFlag;
    };
    /**
     * @inheritdoc
     */
    SessionFetchResultImpl.prototype.size = function () {
        return this.resultList.length;
    };
    /**
     * @inheritdoc
     */
    SessionFetchResultImpl.prototype.totalSelected = function () {
        return this.totalSelectedCount;
    };
    /**
     * @inheritdoc
     */
    SessionFetchResultImpl.prototype.isEmpty = function () {
        return this.resultList.length === 0;
    };
    return SessionFetchResultImpl;
}());
exports.SessionFetchResultImpl = SessionFetchResultImpl;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/features/clients/session-fetch-result.js
// module id = 1831
// module chunks = 1